import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var titleBackButton = createRuntimeFn({defaultClassName:'backButton_titleBackButton__17mrnwq0',variantClassNames:{size:{xsmall:'backButton_titleBackButton_size_xsmall__17mrnwq1',small:'backButton_titleBackButton_size_small__17mrnwq2','default':'backButton_titleBackButton_size_default__17mrnwq3',large:'backButton_titleBackButton_size_large__17mrnwq4'}},defaultVariants:{},compoundVariants:[]});
var titleBackButtonClickable = 'backButton_titleBackButtonClickable__17mrnwq5';

export { titleBackButton, titleBackButtonClickable };
//# sourceMappingURL=backButton.vanilla.mjs.map
